import React from 'react';

const ModulesSection = () => {
  return (
    <section className="modules-section" id="modules">
      <div className="modules-bg"></div>
      <div className="modules-inner">
        <p className="section-eyebrow">The Platform</p>
        <h2 className="section-title light">Five modules. <em>One complete journey.</em></h2>
        <p className="section-intro light" style={{ marginBottom: '36px' }}>
          Subscribe to any module based on where you are — or build the full platform at your pace. ValueARC meets you where you are.
        </p>
        <div className="modules-grid">
          <div className="module-card featured">
            <div className="module-num">Module 1 <span className="mlabel live">Live — 16 Apr 2025</span></div>
            <h3 className="module-title">The M&A Masterclass</h3>
            <p className="module-tagline">The knowledge foundation — everything you need to understand before a buyer ever calls.</p>
            <ul className="module-features">
              <li>4 Founder Readiness Questions &amp; Your Magic Number</li>
              <li>Understanding the Buyer Landscape &amp; Buyer Psychology</li>
              <li>The Data Room — where deals are won or lost</li>
              <li>Quality of Earnings — the number behind the number</li>
              <li>10 Value Maximizers — complete assessment framework</li>
              <li>M&A Sale Process, Deal Structure &amp; Closing</li>
            </ul>
            <div className="module-quote">3 hours · Slide-by-slide narration · Practical, no-jargon preparation</div>
          </div>
          <div className="module-card">
            <div className="module-num">Module 2 <span className="mlabel soon">18 Jun 2026</span></div>
            <h3 className="module-title">Value Maximizer Dashboard</h3>
            <p className="module-tagline">Know exactly where you stand. Track every action. Watch your valuation build — 20–40% uplift potential.</p>
            <ul className="module-features">
              <li>10-Maximizer assessment — scored against buyer standards</li>
              <li>Tailored Plan of Action — sequenced by valuation impact</li>
              <li>Live M&A Readiness Index + valuation uplift tracker</li>
              <li>Per-maximizer: video · case study · guide · DR checklist</li>
            </ul>
            <div className="module-quote">Not a library. A workflow. Every action builds your valuation.</div>
          </div>
          <div className="module-card">
            <div className="module-num">Module 3 <span className="mlabel soon">18 Jun 2026</span></div>
            <h3 className="module-title">Intelligent VDR — iVDR</h3>
            <p className="module-tagline">Not just storage. A founder-guided data room command centre — audit-ready from day one.</p>
            <ul className="module-features">
              <li>Buyer-dept folder guidance — Financial, Legal, HR, Tech</li>
              <li>Real-time status: complete · gaps · red flags · reports</li>
              <li>Granular access control by user, role &amp; deal stage</li>
              <li>Integrated messaging — tracked, timestamped, audit-ready</li>
            </ul>
            <div className="module-quote">Buyers know exactly what to look for. Now, so do you.</div>
          </div>
          <div className="module-row2">
            <div className="module-card">
              <div className="module-num">Module 4 <span className="mlabel tba">To Be Announced</span></div>
              <h3 className="module-title">Go to Market</h3>
              <p className="module-tagline">Every document that opens your M&A process — professionally crafted and data-room-aligned.</p>
              <ul className="module-features">
                <li>Blind Profile — anonymised buyer teaser</li>
                <li>CIM — 50–100 page confidential memorandum</li>
                <li>NDA &amp; qualified buyer targeting list</li>
                <li>Numbers from iVDR · narrative from maximizers — fully aligned</li>
              </ul>
              <div className="module-quote">When you complete this module — you are genuinely ready to go to market. Ready.</div>
            </div>
            <div className="module-card">
              <div className="module-num">Module 5 <span className="mlabel tba">To Be Announced</span></div>
              <h3 className="module-title">Buyer Management &amp; Outreach</h3>
              <p className="module-tagline">We find the right buyers, manage the full process, and get you to the closing table.</p>
              <ul className="module-features">
                <li>Buyer outreach — warm introductions &amp; banker networks</li>
                <li>Management meeting coaching &amp; preparation</li>
                <li>IOI, LOI &amp; full transaction management as your M&A advisor</li>
                <li>Offer evaluation — price, structure, earn-out risk, fit</li>
              </ul>
              <div className="module-quote">From the first buyer outreach to the day the wire clears — we are in the process with you.</div>
            </div>
            <div className="flex-banner">
              <div>
                <div className="flex-banner-text">Subscribe to any module — start where you are, build the full journey.</div>
                <div className="flex-banner-sub">Every module is self-contained and valuable on its own. No all-or-nothing commitment required.</div>
              </div>
              <a href="#enroll" className="flex-banner-cta">Get Started</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ModulesSection;
